//Authentication
export const RESET_PASSWORD = "/reset-password"
export const UPDATE_PASSWORD = "/auth/changePassword"
export const RESET_AGENCY_PASSWORD = "/reset-agency-user-password"
export const FORGOT_PASSWORD = "/forgot-Password"

// Banners
export const CREATE_BANNER = "/banner"
export const GET_BANNERS = "/banner"
export const GET_SINGLE_BANNER = "/banner"
export const UPDATE_BANNERS = "/banner"

// Products
export const GET_ALL_PRODUCTS = "/product"
export const GET_CARREFOUR_SCRAPE_LIST_BY_ID = "/product/scrape/carrefour"
export const UPDATE_PRODUCT = "/product"
export const GET_POTENTIAL_MATCHES = "/product"
export const SET_PRODUCT_MATCH = "/product"
// Scraper
export const SCRAPE_STATUS  = "/scrape/status"
export const SCRAPE_JOBS    = "/scrape/jobs"
export const SCRAPE_AMAZON  = "/scrape/amazon"
export const SCRAPE_CARREFOUR = "/scrape/carrefour"
export const SCRAPE_ALL     = "/scrape/all"
export const SCRAPE_STOP    = "/scrape/stop"
export const SCRAPE_MATCH   = "/product/scrape/match"

// Product Links
export const PRODUCT_LINKS  = "/product-link"

// Users
export const GET_ALL_USERS = "/user/all"
export const GET_USER_CART = "/cart"

// Dashboard
export const GET_DASHBOARD_DATA = "/dashboard"

// Categories
export const GET_CATEGORY_DATA = "/category"
export const GET_PARENT_CATEGORY_DATA = "/category/parentCategories"
export const GET_CHILD_CATEGORY_DATA = "/category/childCategories"
export const UPDATE_CATEGORY_DATA = "/category"